var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 256H16V376H496V256Z",
    fill: "#F1C40F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V256H496V16Z",
    fill: "#3498DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 376H16V496H496V376Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M465.188 135.999L416.716 138.832L462.804 154.114L415.25 144.304L455.812 170.993L412.417 149.211L444.689 185.489L408.411 153.217L430.194 196.611L403.505 156.049L413.314 203.603L398.033 157.515L395.2 205.988L394.597 135.396L465.188 135.999Z",
    fill: "#F1C40F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M395.2 156.676C406.62 156.676 415.877 147.419 415.877 135.999C415.877 124.58 406.62 115.322 395.2 115.322C383.78 115.322 374.523 124.58 374.523 135.999C374.523 147.419 383.78 156.676 395.2 156.676Z",
    fill: "#F1C40F",
    stroke: "#3498DB",
    strokeWidth: 3.65035
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRw);
export default __webpack_public_path__ + "static/media/RW.5dac57be8837dec996146c4e6c8b04a3.svg";
export { ForwardRef as ReactComponent };